import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ModulosService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerTodosModulo(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          modulo {
            obtenerTodos(paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  categoria_modulo_codigo
                  nombre
                  activado
                  fecha_creacion
                  endpoint
                  orden
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.modulo.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerModulosSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: moduloInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          modulo {
            obtenerModulosSegunFiltro(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  categoria_modulo_codigo
                  categoria_modulo_nombre
                  nombre
                  activado
                  fecha_creacion
                  endpoint
                  orden
                  habilitar_bloqueo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.modulo.obtenerModulosSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  modificar(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation ($entidad: moduloInputType) {
          modulo {
            modificar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                categoria_modulo_codigo
                nombre
                activado
                fecha_creacion
                endpoint
                orden
                habilitar_bloqueo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.modulo.modificar
        callback({ mensajes, respuesta })
      }
    );
  }
}
